<template>
  <div class="google-map" :id="mapName" style="height: 100%;"></div>
</template>

<script>
export default {
  name: "OfferLocation",
  props: {
    offer: Object,
    disableUI: Boolean,
    darkUi: Boolean
  },

  data() {
    return {
      mapName: this.name + "-map",
      markers: [],
      map: null
    };
  },

  methods: {
    setCoords() {
      const outletCoords = this.offer.applies.map(outlet => {
        return {
          latitude: parseFloat(outlet.location.lat),
          longitude: parseFloat(outlet.location.lon)
        };
      });
      return outletCoords;
    },

    buildMarker() {
      const outletCoords = this.setCoords();
      let marker = null;
      outletCoords.forEach(outlet => {
        marker = new google.maps.Marker({
          position: { lat: outlet.latitude, lng: outlet.longitude },
          map: this.map
        });

        this.markers.push(marker);
        let bounds = new google.maps.LatLngBounds();

        this.markers.forEach(marker => {
          const latLng = new google.maps.LatLng(
            marker.position.lat(),
            marker.position.lng()
          );
          bounds.extend(latLng);
        });

        this.map.fitBounds(bounds);
        this.map.panToBounds(bounds);

        this.offer.applies.forEach(outlet => {
          const infoWindow = new google.maps.InfoWindow({
            content: outlet.address.address
          });

          marker.addListener("click", () => {
            infoWindow.open(this.map, marker);
          });
        });
      });
    },

    clearMarker() {
      this.markers.forEach(marker => {
        marker.setMap(null);
      });
    }
  },

  watch: {
    "offer.applies": {
      handler: async function(val) {
        const coords = await this.setCoords();
        this.buildMarker();
      },
      deep: true
    },

    offer: function(val) {
      this.clearMarker();
      this.buildMarker();
    }
  },

  async mounted() {
    let bounds = new google.maps.LatLngBounds();
    const disableUI = this.disableUI;
    this.map = new google.maps.Map(document.getElementById(this.mapName), {
      center: {
        lat: parseFloat(this.offer.applies[0].location.lat),
        lng: parseFloat(this.offer.applies[0].location.lon)
      },
      disableDefaultUI: disableUI,
      scaleControl: true,
      styles: [
        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
        {
          elementType: "labels.text.stroke",
          stylers: [{ color: "#242f3e" }]
        },
        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#263c3f" }]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{ color: "#6b9a76" }]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#38414e" }]
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#212a37" }]
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9ca5b3" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#746855" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#1f2835" }]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{ color: "#f3d19c" }]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#2f3948" }]
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [{ color: "#d59563" }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#17263c" }]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#515c6d" }]
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#17263c" }]
        }
      ]
    });

    this.clearMarker();
    this.buildMarker();
  }
};
</script>

<style lang="scss" scoped>
.google-map {
  margin: 0 auto;
  height: 300px;
  background: gray;
}
</style>
